export const REQUESTED_WITH = 'forgerock-sdk';
export const X_REQUESTED_PLATFORM = 'javascript';
//# sourceMappingURL=index.js.map